import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { useFieldArray, useWatch } from 'react-hook-form'

import { dictionariesQueries } from '@/api/dictionaries/dictionariesQueries'
import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import AtomNotice from '@/components/Atoms/AtomNotice/AtomNotice'

import { formatColumnNumber } from './priceColumnFormat'
import {
  type PriceFieldContext,
  PriceSelectField,
  PriceTextField,
} from './PriceFields'
import pricesCn from './PricesStep.module.scss'

function CurrencyFields({ context }: { context: PriceFieldContext }) {
  const currencyColumnNumber = useWatch({
    control: context.control,
    name: 'currencyColumnNumber',
  })
  const currenciesQuery = useQuery(dictionariesQueries.currencies())
  const { fields, append, remove } = useFieldArray({
    control: context.control,
    name: 'currencyTextMapping',
  })
  const currencyOptions = (currenciesQuery.data ?? []).map((currency) => ({
    value: String(currency.code),
    label: `${currency.description} (${currency.code})`,
  }))
  const columnError = context.errors.currencyColumnNumber?.message

  return (
    <>
      <AtomNotice type={columnError ? 'error' : 'info'}>
        {columnError
          ? `${columnError} на шаге «Настройки» в блоке «Файл и колонки»`
          : `Валюта берётся из колонки ${formatColumnNumber(currencyColumnNumber)} и распознаётся по справочнику валют. Таблица ниже дополняет справочник`}
      </AtomNotice>
      {fields.map((field, index) => (
        <div key={field.id} className={pricesCn.mappingRow}>
          <PriceTextField
            context={context}
            name={`currencyTextMapping.${index}.key`}
            title="Текст в файле"
            placeholder="руб."
          />
          <PriceSelectField
            context={context}
            name={`currencyTextMapping.${index}.value`}
            title="Валюта"
            options={currencyOptions}
            loading={currenciesQuery.isPending}
          />
          <AtomButton
            variant="secondary"
            icon={<DeleteOutlined />}
            aria-label="Удалить строку"
            onClick={() => remove(index)}
          />
        </div>
      ))}
      <div>
        <AtomButton
          variant="secondary"
          icon={<PlusOutlined />}
          onClick={() => append({ key: '', value: '' })}
        >
          Добавить текст валюты
        </AtomButton>
      </div>
    </>
  )
}

export default CurrencyFields
